/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { CrownShape } from './CrownShape';
import { Shape } from './CrownShapeCap';
import { Solids } from '@sick-davinci/glow';
import { LineSegments, Vector3 } from 'three';
let Shape3DLineSegment = class Shape3DLineSegment extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        const geometry = Solids.createLineSegment(shape.point1.x, shape.point1.y, shape.point1.z, shape.point2.x, shape.point2.y, shape.point2.z);
        if (decoration != null && decoration.LineWidth > 0) {
            this.add(new LineSegments(geometry, CrownShape.getLineMaterial(decoration)));
        }
    }
    format() {
        const { source } = this.transformPose();
        return {
            point1: (new Vector3(source.point1.x, source.point1.y, source.point1.z)).applyMatrix4(this.matrix),
            point2: (new Vector3(source.point2.x, source.point2.y, source.point2.z)).applyMatrix4(this.matrix),
        };
    }
};
Shape3DLineSegment = tslib_1.__decorate([
    Shape('Shape3D.LineSegment'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], Shape3DLineSegment);
export { Shape3DLineSegment };
//# sourceMappingURL=Shape3DLineSegment.js.map